.input {
	--input-color-background: var(--color-surface);
	--input-color-border: var(--color-border);
	display: block;
	font-size: var(--text-body);
	padding: var(--size-3) var(--size-5);
	border-radius: var(--radius-lg);
	border: var(--size-border) solid var(--input-color-border);
	background-color: var(--input-color-background);
	background-clip: padding-box;
	transition:
		border-color 0.1s ease,
		background-color 0.1s ease,
		outline 0.1s ease;

	&::placeholder {
		color: var(--color-text-silent);
	}

	&:is(textarea) {
		resize: vertical;
	}

	&:disabled,
	&:read-only,
	&[readonly] {
		cursor: default;
		opacity: 0.5;
	}

	&:not(:where(:disabled, :read-only, [readonly])) {
		&:hover {
			--input-color-background: var(--color-surface-hover);
			--input-color-border: var(--color-border-hover);
		}

		&:focus-visible {
			--input-color-border: var(--color-border-focus);
		}
	}
}
